import api from '../../service/api';

export const getCampaigns = async (page, textSearch) => await api.post(`/campaign/list/${page}`, { "query": textSearch });

export const filedCampaign = async (id) => await api.put(`/campaign/${id}/archive`);
export const downloadCampaign = async (id) => await api.get(`/campaign/${id}/influencers/export`);
export const cloneCampaign = async (id) => await api.post(`/campaign/${id}/duplicate`);
export const excludeCampaignDraft = async (id) => await api.delete(`/campaign/${id}/draft`);

